// import { create } from 'zustand';
// import { Category } from '../types';

// interface CategoryState {
//   categories: Category[]; // Список всех категорий
//   activeCategories: Category[]; // Текущие активные категории
//   setCategories: (categories: Category[]) => void; // Установка всех категорий
//   setActiveCategories: (categories: Category[]) => void; // Установка активных категорий
// }

// export const useCategoryStore = create<CategoryState>((set) => ({
//   categories: [],
//   activeCategories: [],

//   setCategories: (categories) => set({ categories }),
//   setActiveCategories: (categories) => set({ activeCategories: categories }),
// }));


import { create } from "zustand";
import { fetchCategories } from "../services/categoriesService";

interface Category {
  id: number;
  name: string;
  parent_id?: number;
  children?: Category[];
  created_at: string;
  updated_at: string;
}

interface CategoriesStore {
  categories: Category[];
  activeCategories: Category[]; // Активные категории для навигации
  loading: boolean;
  error: string | null;

  fetchCategories: () => Promise<void>;
  setActiveCategories: (categories: Category[]) => void; // Установить активные категории
  resetActiveCategories: () => void; // Сбросить активные категории
}

export const useCategoriesStore = create<CategoriesStore>((set, get) => ({
  categories: [],
  activeCategories: [],
  loading: false,
  error: null,

  fetchCategories: async () => {
    if (get().categories.length > 0) return; // Если категории уже загружены, не выполняем запрос
    set({ loading: true, error: null });
    try {
      const categories = await fetchCategories();
      set({ categories, loading: false });
    } catch (err) {
      console.error("Ошибка загрузки категорий:", err);
      set({ error: "Ошибка загрузки категорий", loading: false });
    }
  },

  setActiveCategories: (categories) => set({ activeCategories: categories }),
  resetActiveCategories: () => set({ activeCategories: [] }),
}));
